module.exports = __webpack_public_path__ + "img/img6.0af75f11.png";